import React from "react";
import parse from "html-react-parser";
import { graphql, Link } from "gatsby";

import Meta from "@components/Meta";

import { BuildEffects } from "@components/transition";
import { InitialColorProvider } from "@components/layout/SectionColor";
import Rule from "@components/Rule";

import { parseCareersPage } from "@js-utils/contentful/careers";

import styles from "./careers.module.scss";
import generateSlug from "@js-utils/generate-slug";

export default function CareersPage(props) {
  const { header, pageMeta, careers } = parseCareersPage(props.data.contentfulCareersPage);

  return (
    <>
      <Meta pageTitle={"Careers"} pageMeta={pageMeta} />
      <section
        className={styles.base}
        data-page-background-color="var(--color-black)"
        data-page-accent-color="var(--color-blue)"
        data-page-is-dark
      >
        <InitialColorProvider
          backgroundColor="var(--color-black)"
          accentColor="var(--color-blue)"
          isDark
        />

        <header>
          <BuildEffects.RuleWipe className={styles.rule}>
            <Rule>{header.ruleLabel}</Rule>
          </BuildEffects.RuleWipe>
          <div>
            <h1>
              <BuildEffects.TextMask>Careers, not jobs</BuildEffects.TextMask>
            </h1>
            <BuildEffects.FadeUp>
              <div className={styles.description}>{parse(header.subheading)}</div>
            </BuildEffects.FadeUp>
          </div>
        </header>

        <div className={styles.list}>
          {careers.map(({ id, title, description, link }) => (
            <BuildEffects.FadeUp el="article" key={id} className={styles.item}>
              <h2>{title}</h2>
              <div className={styles.description}>{parse(description)}</div>
              <Link className={styles.applyLink} href={`/careers/${generateSlug(title)}`}>
                Learn More
              </Link>
            </BuildEffects.FadeUp>
          ))}
          {careers.length === 0 && <div className={styles.description}>{parse(header.noJobs)}</div>}
        </div>
      </section>
    </>
  );
}

export const PageQuery = graphql`
  query CareersPageQuery {
    contentfulCareersPage {
      pageMeta {
        ...PageMetaData
      }
      eyebrow
      description {
        childMarkdownRemark {
          html
        }
      }
      noJobs {
        childMarkdownRemark {
          html
        }
      }
      careers {
        ... on ContentfulCareer {
          id
          title
          description {
            childMarkdownRemark {
              html
            }
          }
        }
      }
    }
  }
`;
